/**
 * @module language.transformer
 */

/**
 * Create "language" entities for the front-end
 *
 * @example language (from server)
 * {
 *   "id": 1,
 *   "langISOCode": "en-ca"
 * }
 */
const languageFrom = (language = {}) => {
  return {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
    id: language.id,
    // @ts-expect-error TS(2339): Property 'langISOCode' does not exist on type '{}'... Remove this comment to see the full error message
    code: language.langISOCode,
  };
};

/**
 * Creates a dictionary that maps language ISO codes to database IDs for quick
 * reference when all you have is the ISO code. Compliments the regular
 * `languages` entities as a convenience data structure.
 *
 * @param {Array} - languageList (as generated from `languagesFrom()`)
 * @returns {Object} - a dictionary that maps ISO codes to database IDs
 *
 * @example
 * languageCodeIds: {
 *   'en-ca': 1,
 *   'fr-ca': 2
 * }
 */
const languageCodeIdsFrom = (languages = []) => {
  return languages.reduce((dict, lang) => {
    return {
      ...dict,
      // @ts-expect-error TS(2339): Property 'code' does not exist on type 'never'.
      [lang.code]: lang.id,
    };
  }, {});
};

/**
 * Returns both an set of language entities + a map of ISO codes to ids.
 *
 * @param {Array} languageList - a list of language objects from server (see `languageFrom()`)
 * @returns {Array} an array of 2 elements: 1. languages, 2. languageCodeIds
 */
const languagesFrom = (languageList = []) => {
  const languages = languageList.map((language) => languageFrom(language));
  // @ts-expect-error TS(2345): Argument of type '{ id: any; code: any; }[]' is no... Remove this comment to see the full error message
  const languageCodeIds = languageCodeIdsFrom(languages);

  return [languages, languageCodeIds];
};

export { languageFrom, languagesFrom, languageCodeIdsFrom };
